import type { FaireProductEntity } from "../../entity_types/product";

export const p_t5pqsyjps7: FaireProductEntity = {
  token: "p_t5pqsyjps7",
  type: "product",
  name: "Gochugaru Chili Oil – For Cooking, Drizzling, Dressing, Dips",
  brandToken: "b_wzx8v3srb4",
  brandName: "Algae Cooking Club",
  imageUrl:
    "https://cdn.faire.com/fastly/98587b46d360eae74c8c6a0a3fa5943537aafee05c8c196921e4a8ae85bc86ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1d1f5bee7a85778d7eddb027916825e2ecf15a6a5aee69ece9236ccfe2cdb4c.jpeg",
    "https://cdn.faire.com/fastly/db8b271e67948d89d5921d8451b2db42801528c2608271f22527bcd8c14ee369.png",
    "https://cdn.faire.com/fastly/85c5b8a848b034e6ba9d08ba895245ae0821283b2a707a89be65c4def2026922.jpeg",
    "https://cdn.faire.com/fastly/7d2da5cd92ef9f7331cebd9039b12b1a7022e5f7ae10ff454bc90aa2d3d6f39f.jpeg",
    "https://cdn.faire.com/fastly/cdf6260e23882d3878ca25da7d69e9880b80bd315132d2953bf873c7180ed92d.jpeg",
    "https://cdn.faire.com/fastly/ae974d3817231a704781d32980cb115b38129e0903a7da4aa1f98c1883a70b54.png",
  ],
  priceDollars: 8.5,
  description:
    "🔥 Spicy. Savory. Chef-Crafted. Elevate every dish with this Gochugaru Chili Oil, infused with the bold, smoky heat of Korean gochugaru chili flakes. Developed with Chef Daniel Humm of Eleven Madison Park, this premium finishing oil blends slow-infused chili flavor with the buttery smoothness of our signature algae oil, known for its high smoke point and clean taste. \n\n💡 Why You'll Love It:\n✔️ Bold, Aromatic Heat – Perfectly balanced spice that enhances without overpowering\n✔️ Drizzle-Worthy Texture – Light, silky, and never greasy\n✔️ Versatile & Flavorful – Use it for finishing, marinating, dipping & dressing\n✔️ Healthier Alternative – Clean-label, plant-based, and rich in Omega-9\n\n✨ Perfect Pairings:\n🔥 Stir-fries, noodles, and dumplings\n🥗 Salads, roasted veggies & grain bowls\n🍕 Pizza, avocado toast & eggs\n🍜 Ramen, bibimbap & poke bowls\n\n👩 🍳 Pro Tip: Add a spoonful to pasta, grilled meats, or soups for an instant flavor boost",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:57.907Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
